import axios from "axios";

export default {
  async puxarDadosSalvosServidorAps({ commit, getters }, url) {
    if (getters.getIsFetchedAps) return;
    commit("setFetchedAps", true);

    commit("setHabilitarQuestionarioAps", true); // temporario (remover quando aps funcional dnv)

    const { data } = await axios.get(url);

    console.log(data[0]);

    if (data.length === 0) {
      commit("setHabilitarQuestionarioAps", true);
      return;
    }

    commit("setPayloadServidorAps", data[0]);
    commit("setHabilitarQuestionarioAps", true);
    commit("setTemAps", true);
  },
  async puxarProntuarios({ commit }, url) {
    const { data } = await axios.get(url);

    if (!data) return;

    commit("setProntuarios", data);
  }
};
